import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { RowApi } from './StrukturdatenRowApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Strukturdaten.Paragraph
 * Absatz im Dokument
 * Endpoints: /api/v2/versicherungen/fahrrad/v2/schaden, /api/versicherungen/idd/dokumentspeichern
 */
export class ParagraphApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ParagraphApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected title: string;
	/**
	 * Description: Titel des Absatz: "Meine persönlichen Angaben"
	 * APIL Type: string
	 */
	get Title(): string {
		return this.title;
	}

	/**
	 * Description: Titel des Absatz: "Meine persönlichen Angaben"
	 * APIL Type: string
	 */
	set Title(value: string) {
		this.title = value;
	}

	protected rows: RowApi[];
	/**
	 * Description: Inhalt eder einzelnen Zeilen des Absatz
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Strukturdaten.Row>
	 */
	get Rows(): RowApi[] {
		return this.rows;
	}

	/**
	 * Description: Inhalt eder einzelnen Zeilen des Absatz
	 * APIL Type: Collection<ADAC.Internet.Core.Models.Strukturdaten.Row>
	 */
	set Rows(value: RowApi[]) {
		this.rows = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ParagraphApi {
		return AppUtils.Helper.createFromMap(dataObject, ParagraphApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'rows':
					const resultrows = new Array<RowApi>();
					if (value && Array.isArray(value)) {
						value.forEach((v: any) => {
							resultrows.push(RowApi.createFromObject(v));
						});
					}
					return resultrows;
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Title = this.title;
		const rowsArrayReqObject: object[] = [];
		this.rows.forEach((element) => {
			rowsArrayReqObject.push(element.toRequestObject());
		});
		result.Rows = rowsArrayReqObject;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}